var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kanban-container p-3" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-nowrap overflow-auto h-100 kanban-board" },
      _vm._l(_vm.localColumns, function(column) {
        return _c(
          "div",
          { key: column.id, staticClass: "kanban-col d-flex flex-column" },
          [
            _c(
              "div",
              { staticClass: "kanban-col-header" },
              [
                _c("span", { staticClass: "font-weight-bold text-truncate" }, [
                  _vm._v(_vm._s(column.title))
                ]),
                _vm._v(" "),
                _c(
                  "b-badge",
                  { staticClass: "kanban-badge-custom", class: column.class },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(column.items.length) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "kanban-col-body" },
              [
                _c(
                  "draggable",
                  {
                    staticClass: "kanban-draggable-area",
                    attrs: {
                      group: _vm.groupName,
                      animation: "200",
                      "ghost-class": "ghost-card"
                    },
                    on: {
                      change: function(evt) {
                        return _vm.onItemMoved(evt, column.id)
                      }
                    },
                    model: {
                      value: column.items,
                      callback: function($$v) {
                        _vm.$set(column, "items", $$v)
                      },
                      expression: "column.items"
                    }
                  },
                  [
                    _vm._l(column.items, function(item) {
                      return _vm._t("card", null, { item: item })
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0378ba28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0378ba28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/Kanban.vue
// module id = null
// module chunks = 